module.exports = __webpack_public_path__ + "media/customer_tickets/profile-b7cdfc23.svg";